import React from 'react';
import PropTypes from 'prop-types';
const arr = [{ name: 'test', category: 'carrier' }, { name: 'test1', category: 'operations' }];
const Table = props => (
  <div className="module-table top">
    <table>
      <thead>
        <tr>
          <th className="bd left">
            <a onClick={props.handleSort}>
              {props.language.account.table.name} <i className="fas fa-arrows-alt-v" />
            </a>
          </th>
          <th className="th200 left">
            {props.language.account.table.code}
            <div>
              <i className="fas fa-question-circle" />
              <span>{props.language.account.help.codeVehicle}</span>
            </div>
          </th>
          {props.tags.map(item => (
            <th className="left" key={item}>
              {props.language.filter[item.toLowerCase()]}
            </th>
          ))}
          <th className="th250 left">
            {props.language.account.table.dataSource}
            <div>
              <i className="fas fa-question-circle" />
              <span>{props.language.account.help.dataSourceVehicle}</span>
            </div>
          </th>
          <th className="th200 left">
            {props.language.account.table.state}
            <div>
              <i className="fas fa-question-circle" />
              <span>
                {props.language.account.help.state.title}
                <ul>
                  <li>
                    <strong className="green">
                      {props.language.account.help.state.listDatasource.name}
                    </strong>
                    {props.language.account.help.state.listDatasource.textVehicle}
                  </li>
                  <li>
                    <strong className="red">
                      {props.language.account.help.state.noListDatasource.name}
                    </strong>
                    {props.language.account.help.state.noListDatasource.textVehicle}
                  </li>
                </ul>
              </span>
            </div>
          </th>
          {props.buttonShow && <th className="th100"> {props.language.account.table.setting}</th>}
        </tr>
      </thead>
      <tbody>
        {props.datos.map((item, i) => (
          <tr key={`row-${i}`}>
            <td className={!item.state ? 'bd-gray' : item.hasHomologation ? 'bd-green' : 'bd-red'}>
              {item.alias}
            </td>
            <td>{item.code}</td>
            {props.tags.map(tags => {
              const index = item.tags
                .map(function(e) {
                  return e.tagCategory;
                })
                .indexOf(tags.toUpperCase());
              return (
                <td key={tags}>
                  {index >= 0
                    ? item.tags.map((child, i) => {
                        let count = 0;
                        if (child.tagCategory.toUpperCase() == tags.toUpperCase()) {
                          count++;
                        }
                        return child.tagCategory.toUpperCase() == tags.toUpperCase()
                          ? `${child.tag} `
                          : '';
                      })
                    : ''}
                </td>
              );
            })}
            <td>
              {item.homologations.map((datasource, i) => {
                if (i == 0) {
                  return (
                    <span key={i}>
                      <strong>{datasource.dataSource}</strong>: {datasource.externalEntityId}
                    </span>
                  );
                } else {
                  return (
                    <span key={i}>
                      , <strong>{datasource.dataSource}</strong>: {datasource.externalEntityId}
                    </span>
                  );
                }
              })}
            </td>
            <td className={item.hasHomologation ? 'green' : 'red'}>
              {
                item.hasHomologation
                ? props.language.account.filterDriver.associatedDriverOne
                : props.language.account.filterDriver.PendingPartnership
              }
            </td>
            {props.buttonShow && (
              <td>
                <div className="button-setting flex justify-center">
                  <div />
                  {item.state ? (
                    <div>
                      <a>
                        <span className="hover-title">
                          {props.language.account.geozone.modalEdit.editText}
                        </span>{' '}
                        <i
                          data-datos={JSON.stringify(item)}
                          data-close="ok"
                          onClick={props.handleModal}
                          className="fas fa-edit"
                        />{' '}
                      </a>
                      <a>
                        <span className="hover-title">
                          {' '}
                          {props.language.account.geozone.modalEdit.deactivateText}
                        </span>{' '}
                        <i
                          data-datos={JSON.stringify(item)}
                          data-close="ok"
                          onClick={props.handleModalDelete}
                          className="fas fa-ban"
                        />{' '}
                      </a>
                    </div>
                  ) : (
                    <div>
                      <a>
                        <span className="hover-title">
                          {props.language.account.geozone.modalEdit.activateText}
                        </span>{' '}
                        <i
                          data-datos={JSON.stringify(item)}
                          data-close="ok"
                          onClick={props.handleModalActive}
                          className="fas fa-smile"
                        />{' '}
                      </a>
                    </div>
                  )}
                </div>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
    {props.loadingTable && (
      <div className="loading-table">
        <h6>
          <i className="fas fa-spinner fa-spin" />
        </h6>
      </div>
    )}
    {props.pag >= props.count.pages && (
      <div className="loading-table">
        <h6>{props.datos.length > 0 ? props.language.account.table.endTime : props.language.account.others.noData}</h6>
      </div>
    )}
  </div>
);

export default Table;



// WEBPACK FOOTER //
// ./source/client/components/account_vehicle/table.jsx